/**
 * Kameleoon Feature Flag Experiment 'feature key' constants
 */
export const KameleoonExperiments = {
    BuyNowSearchPage: 'la_buy_now_nav',
    HeaderCategoryClickedTest: 'la_-_header_category_clicked_aa_test',
    LeadingBidderModal: 'leading_bidder_confirmation_modal',
    NewPriceResultsPage: 'new_price_results_page',
    PurchaseProtectionBlurb: 'la_purchase_protection_blurb',
    ReservePriceStatus: 'reserve_status',
    ScoutCategoriesOnCategoryPages: 'la_-_scout_categories_on_category_pages',
} as const;

export type KameleoonExperimentIds = (typeof KameleoonExperiments)[keyof typeof KameleoonExperiments];

export const KameleoonVariants: {
    [key in keyof typeof KameleoonExperiments]: {
        [variant: string]: string;
        Off: 'off';
    };
} = {
    BuyNowSearchPage: {
        Control: 'control',
        Off: 'off',
        On: 'buy_now',
    },
    HeaderCategoryClickedTest: {
        Control: 'control',
        Off: 'off',
        Variant: 'variant',
    },
    LeadingBidderModal: {
        Control: 'control',
        LeadingBidder: 'variant',
        Off: 'off',
    },
    NewPriceResultsPage: {
        Control: 'control',
        Off: 'off',
        Variant: 'variant',
    },
    PurchaseProtectionBlurb: {
        Control: 'control',
        Off: 'off',
        On: 'on',
    },
    ReservePriceStatus: {
        Control: 'control',
        Off: 'off',
        On: 'on',
    },
    ScoutCategoriesOnCategoryPages: {
        Control: 'control',
        Off: 'off',
        Variant: 'variant_1',
    },
} as const;

export type KameleoonExperimentsVariantIds = (typeof KameleoonVariants)[keyof typeof KameleoonVariants];
